import { useState } from "react"
import { useSnackbar } from "../../../context/snackbar"

function CreateList({ setRefresh }) {
  const API = `${process.env.REACT_APP_API_URL}/api/lists`

  const [name, setName] = useState("")
  const { showSnackbar } = useSnackbar()

  const createList = async () => {
    if (!name.trim()) {
      showSnackbar("List name is required", "error")
      return
    }

    try {
      const res = await fetch(API, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({ name }),
      })

      const data = await res.json()

      if (!res.ok) {
        showSnackbar(data.message || "Failed to create list", "error")
        return
      }

      setName("")
      setRefresh(true)

      showSnackbar("List created successfully", "success")
    } catch (err) {
      console.error("Create list error:", err)
      showSnackbar("Something went wrong", "error")
    }
  }

  return (
    <div className="modal fade" id="createListModal" tabIndex="-1">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Create List</h5>
            <button className="btn-close" data-bs-dismiss="modal"></button>
          </div>

          <div className="modal-body">
            <input
              className="form-control"
              placeholder="List name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="modal-footer">
            <button className="btn btn-secondary" data-bs-dismiss="modal">
              Cancel
            </button>

            <button
              className="btn btn-primary"
              onClick={createList}
              data-bs-dismiss="modal"
            >
              Create
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CreateList
